/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

export default () => {
  const { getServlet } = actions;
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const { isLogin } = authReducer;
  return useEffect(() => {
    if (isLogin) {
      dispatch(getServlet());
    }
  }, [authReducer.isLogin]);
};
